<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
	}
</script>

<style>
	li {
		list-style: none;
	}

	html,
	body {
		box-sizing: border-box;
		padding: 0px;
		margin: 0px;
		background-color: #eceef2;
	}

	#app {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
	}

	.flex {
		display: flex;
	}

	.x {
		justify-content: center;
	}

	.y {
		align-items: center;
	}

	.sb {
		justify-content: space-between;
	}

	.sa {
		justify-content: space-around;
	}

	.text-x {
		text-align: center;
	}

	.text-right {
		text-align: right;
	}

	.cp {
		cursor: pointer;
	}

	.us {
		user-select: none;
	}

	.ws {
		white-space: nowrap;
	}

	.b {
		font-weight: bold;
	}

	.title {
		font-size: 1.25rem;
		font-weight: bold;
	}

	a {
		display: block;
		text-decoration: none;
		color: #333;
		outline: none;
	}

	.top10 {
		margin-top: 0.625rem;
	}

	.bottom10 {
		margin-bottom: 0.625rem;
	}

	.left10 {
		margin-left: 0.625rem;
	}

	.right10 {
		margin-right: 0.625rem;
	}

	.top20 {
		margin-top: 1.25rem;
	}

	.bottom20 {
		margin-bottom: 1.25rem;
	}

	.left20 {
		margin-left: 1.25rem;
	}

	.right20 {
		margin-right: 1.25rem;
	}

	.margin4 {
		margin: 0.25rem;
	}

	.margin8 {
		margin: 0.5rem;
	}

	.margin12 {
		margin: 0.75rem;
	}

	.margin16 {
		margin: 1rem;
	}

	.margin20 {
		margin: 1.25rem;
	}

	.padding4 {
		padding: 0.25rem;
	}

	.padding8 {
		padding: 0.5rem;
	}

	.padding12 {
		padding: 0.75rem;
	}

	.padding16 {
		padding: 1rem;
	}

	.padding20 {
		padding: 1.25rem;
	}

	.size12 {
		font-size: 0.75rem;
	}

	.size14 {
		font-size: 0.875rem;
	}

	.size16 {
		font-size: 1rem;
	}

	.size18 {
		font-size: 1.125rem;
	}

	.size20 {
		font-size: 1.25rem;
	}

	.size22 {
		font-size: 1.375rem;
	}

	.size24 {
		font-size: 1.5rem;
	}

	.size26 {
		font-size: 1.625rem;
	}

	.size28 {
		font-size: 1.75rem;
	}

	.size30 {
		font-size: 1.875rem;
	}

	.boxShadow {
		box-shadow: 0 1px 4px rgba(0, 0, 0, .2);
		transition: box-shadow 0.3s;
	}

	.boxShadow:hover {
		box-shadow: 0 2px 6px rgba(0, 0, 0, .3);
	}
</style>
